import React, { FC, Fragment, memo } from "react";
import { ContainerChildrenProps } from "./types";

export const ContainerChildren: FC<ContainerChildrenProps> = memo(({ items, isColumn, isMain, renderElement }) => (
  <>
    {items
      ?.filter(item => !["title", "icon"].includes(item.id))
      ?.map((item, index) => (
        <Fragment key={index}>{renderElement({ id: item.id, index, wrap: isColumn || isMain })}</Fragment>
      ))}
  </>
));
